export const BASE_URL = process.env.BASE_URL;
export const READ_BASE_URL = process.env.READ_BASE_URL;

export { FileService } from "./fileService";
export { TranslateService } from "./translateService";
export { FileDirectoryService } from "./fileDirectoryService";
export { OutlineService } from './outlineService';
export { SupportService } from './supportService';